import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import FormGroup from 'components/FormGroup/FormGroup';
import FormItem from 'components/FormItem/FormItem';

import styles from '../../terminal.scss';

const RejectedStep = (props) => {
    const { terminalSettings } = props;

    function openYookassa() {
        window.open(terminalSettings.oauth_redirect_link || 'https://yookassa.ru', '_blank').focus();
    }

    return (
        <FormGroup>
            <FormItem>
                <>
                    <h2 className={styles.yookassaStepTitle}>Не удалось активировать терминал</h2>
                    <p className={styles.note}>
                        Скорее всего, вы выбрали неправильный магазин ЮКассы. Обратите внимание, что вы должны создать
                        новый магазин, который будет использоваться только в Dispurse.
                    </p>
                </>
            </FormItem>
            <FormItem>
                <Button text="Привязать новый магазин" level="secondary" onClick={openYookassa} />
            </FormItem>
        </FormGroup>
    );
};

RejectedStep.propTypes = {
    terminalSettings: PropTypes.shape({
        oauth_redirect_link: PropTypes.string,
    }),
};

export default RejectedStep;
